//3rd Party Components
import React, { Fragment } from 'react';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';
import AUdirectionLink from '@gov.au/direction-links';

//Components
import PageAlert from '../Portal/PageAlert';
import ProcessMessage from '../Portal/ProcessMessage';
import Breadcrumbs from '../CASA/Breadcrumbs'; //AUBreadcrumbs doesn't support embedded html

const Heading = ({ text, subtext, badgetext, breadcrumbs, showcrumbs, showback, ...attributeOptions }) => {

    const setInnerHTML = (value) => {
        return { __html: value };
    };

    const crumbs = () => {
        if (!showcrumbs) {
            return (null)
        }
        else {
            return (
                <Breadcrumbs label="Breadcrumb for this page"
                    items={breadcrumbs}/>
            )
        }
    }

    const subhead = () => {
        if (subtext === "") {
            return (null)
        }
        else {
            return (
                <div className="col-xs-12 col-md-12 col-lg-12">
                    <h2>{subtext}</h2>
                </div>
            )
        }
    }

    const back = () => {
        if (showback && breadcrumbs.length > 1) {
            return (
                <AUdirectionLink link={breadcrumbs[breadcrumbs.length - 2].link} text="Back" direction="left" />
            )
        }
        else {
            return null
        }
    }

    const { level, title, message } = useSelector(state => ({
        level: state.pageAlert.level,
        title: state.pageAlert.title,
        message: state.pageAlert.message
    }));

    const showPageAlert = () => {
        if (level !== '') {
            return (
                <PageAlert level={level} title={title} message={message} />
            );
        }
        else {
            return null;
        }
    }

    //also in module/submodule
    const badge = () => {
        return !badgetext ? null :
            badgetext.level === "error" ?
                React.createElement("span", {
                    key: 1
                },
                    React.createElement("span", {
                        className: "badge badge-error"
                    }, badgetext.message)) :
                badgetext.level === "warning" ?
                    React.createElement("span", {
                        key: 1
                    },
                        React.createElement("span", {
                            className: "badge badge-warning"
                        }, badgetext.message)) :
                    badgetext.level === "success" ?
                        React.createElement("span", {
                            key: 1
                        },
                            React.createElement("span", {
                                className: "badge badge-success"
                            }, badgetext.message)) :
                        badgetext.level === "inprogress" ?
                            React.createElement("span", {
                                key: 1
                            },
                                React.createElement("span", {
                                    className: "badge badge-in-progress"
                                }, badgetext.message)) :
                            React.createElement("span", {
                                key: 1
                            },
                                React.createElement("span", null, badgetext.message)
                            );

    };

    const head = () => {
        return (
            <div className="au-form-group">
                <header className="au-header" role="banner" {...attributeOptions}>

                    {showPageAlert()}

                    <h1 className="break desktop au-header-heading au-display-xl">
                        <span dangerouslySetInnerHTML={setInnerHTML(text)}>
                        </span>
                    </h1>

                    {subhead()}

                    {back()}

                    {badge()}

                </header>
            </div>
        )
    };

    return (
        <Fragment>

            {crumbs()}

            <ProcessMessage />

            {head()}            

        </Fragment>
    )
};

Heading.propTypes = {
    text: PropTypes.string.isRequired,
    subtext: PropTypes.string,
    breadcrumbs: PropTypes.arrayOf(
        PropTypes.shape({
            link: PropTypes.string,
            text: PropTypes.string.isRequired,
        })
    ).isRequired,
    showcrumbs: PropTypes.bool.isRequired,
    showback: PropTypes.bool,
    badgetext: PropTypes.object
};

Heading.defaultProps = {
    breadcrumbs: [],
    text: "",
    subtext: "",
    badgetext: null,
    showcrumbs: true,
    showback: true
};

export default Heading;